// extracted by mini-css-extract-plugin
module.exports = {"formHeader":"Reservation_formHeader__SlzYn","status":"Reservation_status__11LuD"};